import styled from 'styled-components';
import theme from '@/styles/theme';
import media from '@/styles/media';

/** 조건이 충족되지 않으면  border: red 인 input */
interface InputProps {
  validate: boolean | undefined
}
/** 기본 input */
export const Input = styled.input<InputProps>`
  width: 100%;
  height: 50px;
  margin: 5px 0;
  padding: 17px;
  max-width: 420px;
  box-sizing: border-box;
  background: #FFFFFF;  
  color: ${({ validate }) => (validate === undefined || validate
    ? '#7F85B4' : theme.color.warningRed)}; 
  border: 2px solid  ${({ validate }) => (validate === undefined || validate
    ? theme.color.border : theme.color.warningRed)}; 
  border-radius: 8px;
  box-shadow: 10px 10px 30px rgba(84, 100, 224, 0.1);

  font-family: ${theme.fontFamily.regular};
  font-size: 14px;
  line-height: 16px;

  ::placeholder {
    color: #7F85B4;
    font-size: 12px;
  }

  &:focus {
    outline: none;
    color: ${({ validate }) => (validate === undefined || validate ? '#7F85B4' : theme.color.warningRed)}; 
    border: 2px solid  ${({ validate }) => (validate === undefined || validate ? '#7F85B4' : theme.color.warningRed)}; 
  }

  &:disabled {
    background-color: #EFEFEF;
    color: ${({ validate }) => (validate === undefined || validate ? '#808080' : theme.color.warningRed)}; 
    border: 2px solid  ${({ validate }) => (validate === undefined || validate
    ? theme.color.lightBorder : theme.color.warningRed)}; 
  }
`;

/** disabled된 상태로 사용할 때  */
export const EmailInput = styled(Input)<{centered?:boolean}>`
  ${({ centered }) => centered && 'text-align:center'};
  &:disabled{
    background: #F0F2FE;
    border: 2px solid ${theme.color.border};
    color: #7F85B4;
    font-family:  ${theme.fontFamily.regular};
    font-size: 14px;
    line-height: 17px;
    text-align: center;
  }
  ${media.xs`
    max-width: 340px;
  `}
  ${media.lg`
    ::placeholder {
      text-align: left;
    }
  `}
`;

export const CodeInput = styled(EmailInput)`
text-transform: uppercase;
`;
